import { RequestDeviceInfoCommand } from 'kaistore-post-messenger/src/commands';
import { MessageSender } from 'web-message-helper';

class DeviceUtils {
  constructor() {
    this.information = {};
    this.startListeners();
    this.featureset = {
      bookmarkSupported: false,
      settingsPanelSupported: false
    };
  }

  startListeners() {
    window.addEventListener('languagechange', () => {
      this.rebootRequest();
    });
  }

  rebootRequest() {
    var rebootEvent = new CustomEvent('reboot-needed', {
      detail: 'device-info-change'
    });

    window.dispatchEvent(rebootEvent);
  }

  connectionType(simCard) {
    if (
      navigator.mozWifiManager &&
      navigator.mozWifiManager.connection.status === 'connected'
    ) {
      return 'wifi';
    } else {
      let conns =
        window.navigator.mozMobileConnection ||
        window.navigator.mozMobileConnections;
      return conns[simCard].data.type;
    }
  }

  getTimeZoneOffset() {
    let t = new Date();
    let tzo = -t.getTimezoneOffset();
    if (tzo !== 0) {
      tzo = tzo / 60;
    }
    return tzo;
  }

  getTimeStamp() {
    let t = new Date();
    let tzo = -t.getTimezoneOffset();
    let dif = tzo >= 0 ? '+' : '-';
    return (
      t.getFullYear() +
      '-' +
      (t.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      t
        .getDate()
        .toString()
        .padStart(2, '0') +
      'T' +
      t
        .getHours()
        .toString()
        .padStart(2, '0') +
      ':' +
      t
        .getMinutes()
        .toString()
        .padStart(2, '0') +
      ':' +
      t
        .getSeconds()
        .toString()
        .padStart(2, '0') +
      dif +
      Math.abs(tzo / 60)
        .toString()
        .padStart(2, '0') +
      ':' +
      Math.abs(tzo % 60)
        .toString()
        .padStart(2, '0')
    );
  }

  requestInfo() {
    return new Promise((resolve, reject) => {
      MessageSender.send(new RequestDeviceInfoCommand(), (success, detail) => {
        if (success) {
          // make it as Map
          detail.settings = new Map(Object.entries(detail.settings));
          window.deviceInfos = detail.settings;
          window.deviceInfos.set(
            'ril.data.defaultServiceId',
            detail.connection.defaultServiceId
          );
          this.information = detail;
          resolve();
        } else {
          reject();
        }
      });
    });
  }
}
export const deviceUtils = new DeviceUtils();



/** WEBPACK FOOTER **
 ** ./src/device-utils.js
 **/